import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { initTwa } from './lib/twa.js';
import './styles.css';

initTwa().then(() => {
  const root = createRoot(document.getElementById('root'));
  root.render(<App />);
});
